import type {
  AddFieldPlacementTarget,
  GeneratedSchemaField,
  LoadedAuthoredGeneratedSchema
} from '@cli-types/core-engine/add-field.js'
import type { FormField, FormSchema, Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { promptEntityIntegrationOptions } from './prompt-entity-integration-options.js'
import { promptFormColumnOption } from './prompt-form-column-option.js'

export async function promptSchemaIntegrationOptions(
  context: SchemaPromptContext,
  loaded: LoadedAuthoredGeneratedSchema,
  field: GeneratedSchemaField,
  target: AddFieldPlacementTarget
): Promise<string[]> {
  if (target.scope === 'list-item') {
    return []
  }

  if (loaded.kind === 'form') {
    return promptFormColumnOption(context, loaded.schema as FormSchema, field as FormField)
  }

  if (loaded.kind === 'single') {
    return []
  }

  return promptEntityIntegrationOptions(context, loaded.schema as Schema, field as SchemaField)
}
